module.exports = __webpack_public_path__ + "static/img/resume-cool-rtl.ca05d74.png";